import React from 'react'
import Numbro from 'numbro'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const PriceContainer = styled.div`
	position: fixed;
	top: 250px;
	right: 20px;
	z-index: 999;
	display: flex;
	flex-direction: column;

	@media (max-width: 768px) {
		display: none;
	}
`

const PriceBox = styled.div`
	padding: 1rem;
	background: #838eab;
	color: white;
	font-family: Montserrat;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 0.5rem;
	font-size: 20px;

	@media (max-width: 768px) {
		display: none;
	}
`

const PriceLabel = styled.span`
	margin-bottom: 0.5rem;
`

const PriceValue = styled.span`
	font-weight: bold;
`

export const PriceDisplay = ({
	distance,
	price,
	reduction,
	prixAvecReduction,
}) => {
	const formatPrice = (value) => {
		return Numbro(value ?? 0).formatCurrency({
			currencySymbol: '€',
			currencyPosition: 'postfix',
			mantissa: 2,
		})
	}
    const {t} = useTranslation()
	return (
		<PriceContainer>
			<PriceBox>
				<PriceLabel>Distance</PriceLabel>
				<PriceValue style={{ marginBottom: '1rem' }}>
					{distance / 1000} km
				</PriceValue>
				<PriceLabel>{t("price")}</PriceLabel>
				<PriceValue>{formatPrice(price)} ht</PriceValue>
				{!!reduction && (
					<>
						<PriceLabel style={{ marginTop: '1rem' }}>
							{t("discount")}
						</PriceLabel>
						<PriceValue>
							{formatPrice(prixAvecReduction)} ht
						</PriceValue>
					</>
				)}
			</PriceBox>
		</PriceContainer>
	)
}

